import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeModeProvider } from "./contexts/ThemeModeContext";
import { AuthProvider } from "./components/AuthProvider";
import { AssessmentProvider } from "./components/AssessmentProvider";
import { WorkspaceRecentsProvider } from "./contexts/WorkspaceRecentsContext";
import { ModalOpenProvider } from "./contexts/ModalOpenContext";
import { RuntimeConfigProvider } from "./contexts/RuntimeConfigContext";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initTracking } from "./services/tracking";
import { FrameworkConfigurationProvider } from "./contexts/FrameworkConfigurationContext";

initTracking();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <ErrorBoundary>
        <ModalOpenProvider>
          <RuntimeConfigProvider>
            <AuthProvider>
              <FrameworkConfigurationProvider>
                <AssessmentProvider>
                  <WorkspaceRecentsProvider>
                    <BrowserRouter>
                      <App />
                    </BrowserRouter>
                  </WorkspaceRecentsProvider>
                </AssessmentProvider>
              </FrameworkConfigurationProvider>
            </AuthProvider>
          </RuntimeConfigProvider>
        </ModalOpenProvider>
      </ErrorBoundary>
    </ThemeModeProvider>
  </React.StrictMode>
);
